import { ChatCopyInfo } from '@agent/agent-interface/contact-view/chat/model/chat-copy-info';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatCopyService {
  readonly copyInfo$ = new BehaviorSubject<ChatCopyInfo | undefined>(undefined);
  readonly isPanelOpen$ = new BehaviorSubject<boolean>(false);

  copy(chatCopyInfo: ChatCopyInfo): void {
    chatCopyInfo.copyMessages.forEach(msg => this.replaceImageAttributes(msg.content));
    this.openPanel();
    this.copyInfo$.next(chatCopyInfo);
  }

  private openPanel() {
    this.isPanelOpen$.next(true);
  }

  /**
   *
   * Function to replace all 'img' tag's to img alt name with dots. Please see example below
   * '<img loading="lazy" alt="' + name + '" src="./' + name + '.png"  />' tag's to  ':name:'
   *
   * @param textContent input text to replace
   * @return replaced text
   */
  private replaceImageAttributes(textContent: string) {
    return textContent.replace(/<img.*?alt="(.*?)"[^\>]+>/g, x => {
      let div = document.createElement('div');
      div.innerHTML = x;
      return ':' + div.getElementsByTagName('img')[0].alt + ':';
    });
  }
}
